import React, { useState, useEffect } from 'react'
import { getDaysSinceWeighIn, hostDateToString, todayString } from '../../util'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import IconPracticeMode from '../../../../../../images/new-vacation-mode/practice-mode.png'
import { Accordion } from './components/setting-accordion'
import { SaveButton } from './components/save-button'
import styled from 'styled-components'
import { Toggle } from './components/toggle'
import { UserCheckinWarning } from './components/user-check-in-warning'
import CheckinFormPortal from './components/check-in-2-4'
import { modifyUser } from '../../../../../../api'
import helpTip from '../../../../../../images/change-goal-pictures/helpTip.png'
import Icon from '@material-ui/core/Icon'

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`

const HideTargetText = styled.span`
  margin: 0;
  font-weight: bold;
  color: #333;
  font-size: 1rem;

  @media (max-width: 900px) {
    font-size: .9rem !important;
  }
`;

const UpdatePracticeMode = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [show, setShow] = useState(false);
  const [showVacationModal, setShowVacationModal] = useState(false);
  const [showHideTargetModal, setShowHideTargetModal] = useState(false);
  const [showLogWeeklyBodyMetricsModal, setShowLogWeeklyBodyMetricsModal] = useState(false);
  const [vacationMode, setVacationMode] = useState(null);
  const [vacationModeInfo, setVacationModeInfo] = useState({
    practice_mode: true,
    log_weekly_body_metrics: false,
    hide_protein: false,
    hide_carbs: false,
    hide_fat: false,
  });
  const [showUserCheckinWarning, setShowUserCheckinWarning] = useState(false);
  const [showCheckinFormPortal, setShowCheckinFormPortal] = useState(false);

  useEffect(() => {
    if (props.vacationMode !== null && props.vacationModeInfo?.practice_mode) {
      setVacationMode(props.vacationMode);
      setVacationModeInfo({
        practice_mode: true,
        log_weekly_body_metrics: props.vacationModeInfo?.log_weekly_body_metrics || false,
        hide_protein: props.vacationModeInfo?.hide_protein || false,
        hide_carbs: props.vacationModeInfo?.hide_carbs || false,
        hide_fat: props.vacationModeInfo?.hide_fat || false,
      });
    }
  }, [props.vacationModeInfo, props.vacationMode]);

  useEffect(() => {
    const effectiveVacationMode = vacationMode === null ? props.vacationMode : vacationMode;
    const vacationModeChanged = effectiveVacationMode !== props.vacationMode;
    const practiceModeChanged = vacationModeInfo.practice_mode !== (props.vacationModeInfo?.practice_mode || false);
    const logWeeklyBodyMetricsChanged = vacationModeInfo?.log_weekly_body_metrics !== (props.vacationModeInfo?.log_weekly_body_metrics || false);
    const hideProteinChanged = vacationModeInfo?.hide_protein !== (props.vacationModeInfo?.hide_protein || false);
    const hideCarbsChanged = vacationModeInfo?.hide_carbs !== (props.vacationModeInfo?.hide_carbs || false);
    const hideFatChanged = vacationModeInfo?.hide_fat !== (props.vacationModeInfo?.hide_fat || false);
    
    if (props.vacationModeInfo?.practice_mode === vacationModeInfo.practice_mode) {
      setDisableSubmit(!(vacationModeChanged || logWeeklyBodyMetricsChanged || hideProteinChanged || hideCarbsChanged || hideFatChanged));
    } else if (effectiveVacationMode) {
      setDisableSubmit(!vacationModeChanged);
    }
  }, [vacationModeInfo, vacationMode, props.vacationMode, props.vacationModeInfo]);

  const handleToggle = (preferenceKey) => {
    setVacationModeInfo(prev => ({
      ...prev,
      [preferenceKey]: !prev[preferenceKey]
    }));
  };

  const handleMainToggle = () => {
    const effectiveVacationMode = vacationMode === null ? props.vacationMode : vacationMode;
    const newVacationMode = effectiveVacationMode ? 0 : 1;
    setVacationMode(newVacationMode);
    setDisableSubmit(newVacationMode === props.vacationMode);
  };

  const handleSubmit = () => {
    const effectiveVacationMode = vacationMode === null ? props.vacationMode : vacationMode;
    
    if (effectiveVacationMode === 0) {
      const todayDateString = todayString();
      if (
        hostDateToString(props.lastWeighInDate) === todayDateString ||
        (props.vacationEntryDate &&
          hostDateToString(props.vacationEntryDate) === todayDateString)
      ) {
        setIsSubmitting(true);
        modifyUser(props.userId, props.portalId, { vacation_mode: effectiveVacationMode })
          .then(() => {
            setIsSubmitting(false);
            setShow(false);
            props.loadPortalAccount();
            props.openSnackbar('Practice Mode has been updated successfully', false);
          })
          .catch((err) => {
            setIsSubmitting(false);
            props.openSnackbar('Unable to update Practice Mode', true);
          });
      } else {
        setShowVacationModal(true);
      }
    } else {
      const data = {
        vacation_mode: effectiveVacationMode,
        vacation_mode_info: vacationModeInfo,
      };
      setIsSubmitting(true);
      modifyUser(props.userId, props.portalId, data)
        .then(() => {
          setIsSubmitting(false);
          setShow(false);
          props.loadPortalAccount();
          props.openSnackbar('Preference saved!', false);
        })
        .catch((err) => {
          setIsSubmitting(false);
          props.openSnackbar('Unable to update preference', true);
        });
    }
  };



  const handleReset = () => {
    if (props.vacationMode && props.vacationModeInfo?.practice_mode) {
      setVacationMode(props.vacationMode);
      setVacationModeInfo({
        practice_mode: props.vacationModeInfo?.practice_mode || false,
        log_weekly_body_metrics: props.vacationModeInfo?.log_weekly_body_metrics || false,
        hide_protein: props.vacationModeInfo?.hide_protein || false,
        hide_carbs: props.vacationModeInfo?.hide_carbs || false,
        hide_fat: props.vacationModeInfo?.hide_fat || false,
      });
    } else {
      setVacationMode(0);
      setVacationModeInfo({
        practice_mode: false,
        log_weekly_body_metrics: false,
        hide_protein: false,
        hide_carbs: false,
        hide_fat: false,
      });
      setDisableSubmit(true);
    }
  };

  const daysAfterLastCheckIn = getDaysSinceWeighIn(props.lastWeighInDate);
  const effectiveVacationMode = vacationMode === null ? props.vacationMode : vacationMode;

  return (
    <div>
      <Accordion
        show={show}
        setShow={(val) => setShow(val)}
        handleReset={handleReset}
        settingName="Practice mode"
        icon={IconPracticeMode}
        currentSetting={
          effectiveVacationMode === 1 && vacationModeInfo?.practice_mode ? "On" : "Off"
        }
      >
        <p>
          Turn off check-ins and adjustments to practice logging food without
          the pressure to hit your macros. This can be helpful when you're new
          to the app and first learning how to track macros.
        </p>
        <Toggle
          label="Practice mode"
          checked={effectiveVacationMode !== 0 && vacationModeInfo?.practice_mode}
          onChange={handleMainToggle}
          value="vacationMode"
        />
        {effectiveVacationMode !== 0 && (
          <>
            <p>&nbsp;</p>
            <p style={{textAlign: 'center'}}>Customize your experience while on Practice Mode</p>
            <Toggle
              info={true}
              onInfoClick={() => setShowLogWeeklyBodyMetricsModal(true)}
              label="Log weekly body metrics"
              checked={vacationModeInfo?.log_weekly_body_metrics}
              onChange={() => handleToggle('log_weekly_body_metrics')}
              value="logWeeklyBodyMetrics"
            />
            <p>
              Turn on weekly prompts to log weight and body fat. Adherence to
              your macro targets won't be considered and no adjustments will be
              made.
            </p>
            <p>&nbsp;</p>
            <div style={{display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '16px'}}>
              <Icon onClick={() => setShowHideTargetModal(true)} style={{cursor: 'pointer'}}>help_outline</Icon>
              <HideTargetText>Hide macro targets</HideTargetText>
            </div>
            <p>Track food without aiming for macro targets</p>
            <Toggle
              label="Hide Protein"
              checked={vacationModeInfo?.hide_protein}
              onChange={() => handleToggle('hide_protein')}
              value="vacationMode"
            />
            <Toggle
              label="Hide Carbs"
              checked={vacationModeInfo?.hide_carbs}
              onChange={() => handleToggle('hide_carbs')}
              value="vacationMode"
            />
            <Toggle
              label="Hide Fat"
              checked={vacationModeInfo?.hide_fat}
              onChange={() => handleToggle('hide_fat')}
              value="vacationMode"
            />
          </>
        )}
        <ButtonRow>
          <SaveButton
            onClick={handleSubmit}
            isLoading={isSubmitting}
            disabled={disableSubmit}
          />
        </ButtonRow>
      </Accordion>

      <Dialog open={showVacationModal} onClose={() => setShowVacationModal(false)}>
        <DialogContent className='avn-modal-content-container'>
          <img src={IconPracticeMode} alt="coaching-icon" />
          <h4>Practice mode off</h4>
          <p>Weekly check-ins and adjustments will now resume! Please enter a new starting weight for them.</p>
          <DialogActions>
            <div className='avn-modal-actions-container'>
              <button className='avn-modal-action' onClick={() => { setShowVacationModal(false); setShowCheckinFormPortal(true) }}>Continue</button>
              <button className='avn-modal-action-cancel' onClick={() => { setShowVacationModal(false) }}>Cancel</button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog open={showHideTargetModal} onClose={() => setShowHideTargetModal(false)}>
        <DialogContent className='avn-modal-content-container'>
          <img src={helpTip} alt="coaching-icon" />
          <h4>Why hide your macro targets?</h4>
          <p style={{textAlign: 'center', fontWeight: 'bold'}}>Popular reasons</p>
          <ul>
            <li>You want to practice logging food without the pressure to hit your macros.</li>
            <li>You want to focus on food choices while building tracking skills gradually.</li>
            <li>You want to see how much you normally eat without being influenced by your targets.</li>
            <li>You only want to aim for certain macros while you get the hang of using the system.</li>
          </ul>
          <DialogActions className='avn-modal-actions-container'>
            <button className='avn-modal-action' onClick={() => setShowHideTargetModal(false)}>Ok got it</button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog open={showLogWeeklyBodyMetricsModal} onClose={() => setShowLogWeeklyBodyMetricsModal(false)}>
        <DialogContent className='avn-modal-content-container'>
          <img src={helpTip} alt="coaching-icon" />
          <h4>Why log weekly body metrics?</h4>
          <p style={{maxWidth: '510px'}}>You'll turn these prompts on when you want to continue tracking body
          changes while on Practice Mode. These aren't check-ins–so you don't
          need to hit your macros and you won't receive adjustments–but you will
          be able to record your weight, body fat, body measurements, and
          progress photos each week.</p>
          <DialogActions className='avn-modal-actions-container'>
            <button className='avn-modal-action' onClick={() => setShowLogWeeklyBodyMetricsModal(false)}>Ok got it</button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <UserCheckinWarning
        open={showUserCheckinWarning}
        onClose={() => setShowUserCheckinWarning(false)}
        daysAfterLastCheckIn={daysAfterLastCheckIn}
      />
      
      <CheckinFormPortal
        skipMessage
        vacationSetting
        open={showCheckinFormPortal}
        onClose={() => setShowCheckinFormPortal(false)}
        openFeedback={props.openSnackbar}
        userId={props.userId}
        portalId={props.portalId}
        loadPortalAccount={props.loadPortalAccount}
        weightString={props.weightString}
        previousWeight={props.previousWeight}
        previousBodyfat={props.previousBodyfat}
        useMetricUnits={props.useMetricUnits}
        daysAfterLastCheckIn={daysAfterLastCheckIn}
        gender={props.gender}
      />
    </div>
  );
};

export default UpdatePracticeMode;
